import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
	email: Yup.string().nullable().email('Email should be valid').required('Email is required field').max(253, "Email can't be longer than 253 symbols"),
});
